import React from "react";

import * as Sentry from "@sentry/react";

import ErrorScreen from "./ErrorScreen";

type ErrorBoundaryProps = {
  children: React.ReactNode;
  pathName?: string;
  padding?: string;
};

type ErrorBoundaryState = {
  errorLogged: boolean | null;
  errorFound: boolean;
  errorPathName: string | null;
};

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  constructor(props) {
    super(props);
    this.state = { errorLogged: null, errorFound: false, errorPathName: null };
    this.setError = this.setError.bind(this);
  }

  static getDerivedStateFromError() {
    return { errorFound: true };
  }

  componentDidCatch(err) {
    this.setState({ errorFound: true, errorPathName: this.props.pathName });

    // @ts-ignore
    Sentry.captureException(err);
  }

  setError() {
    this.setState({ errorFound: false });
  }

  componentDidUpdate() {
    const { errorPathName, errorFound } = this.state;
    if (!errorFound) {
      return;
    }
    if (errorPathName && errorPathName !== this.props.pathName) {
      this.setState({ errorFound: false });
    }
  }

  render() {
    const { errorFound } = this.state;
    if (errorFound) {
      return (
        <ErrorScreen setError={this.setError} padding={this.props.padding} />
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
